import '../styles/search.css';
import { useEffect, useState } from 'react';
import { getDocs, collection } from 'firebase/firestore';
import { useNavigate, useSearchParams } from "react-router-dom";
import { db } from '../utils/firebaseconfig';
import ProductCard from '../components/ProductCard';
 
function Search() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("q") || "";
 
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [sortField, setSortField] = useState('title');
  const [sortBy, setSortBy] = useState('Ascending');
 
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snapshot = await getDocs(collection(db, "Product"));
        const productData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
 
        setProducts(productData);
        setFilteredProducts(productData);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
 
    fetchProducts();
  }, []);
 
  useEffect(() => {
    if (searchQuery.length >= 1) {
      const searchResults = products.filter((product) => {
        const productName = product.title || product.name || "";
        const productCategory = product.category || "";
        const keywordsArray = Array.isArray(product.keywords)
          ? product.keywords
          : typeof product.keywords === 'string'
          ? product.keywords.split(',').map(kw => kw.trim())
          : [];
 
        const searchQueryLower = searchQuery.toLowerCase();
       
        return (
          productName.toLowerCase().includes(searchQueryLower) ||
          productCategory.toLowerCase().includes(searchQueryLower) ||
          keywordsArray.some(kw => kw.toLowerCase().includes(searchQueryLower))
        );
      });
      setFilteredProducts(sortProducts(searchResults, sortBy, sortField));
    } else {
      setFilteredProducts(products);
    }
  }, [searchQuery, products, sortBy, sortField]);
 
  const sortProducts = (data, sortBy, sortField) => {
    const sortedData = [...data];
    if (sortField === "price") {
      sortedData.sort((a, b) => sortBy === "Ascending" ? a.price - b.price : b.price - a.price);
    } else {
      sortedData.sort((a, b) => {
        const aValue = (a[sortField] || "").toString();
        const bValue = (b[sortField] || "").toString();
        return sortBy === "Ascending" ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      });
    }
    return sortedData;
  };
 
  const changeSortField = (field) => {
    setSortField(field);
    setFilteredProducts(sortProducts(filteredProducts, sortBy, field));
  };
 
  const changeSortType = (type) => {
    setSortBy(type);
    setFilteredProducts(sortProducts(filteredProducts, type, sortField));
  };
 
  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };
 
  return (
    <div>
      <div className='felid'>
        <select name='field' onChange={(e) => changeSortField(e.target.value)}>
          <option value="title">Sort by Name</option>
          <option value="price">Sort by Price</option>
          <option value="rating">Sort by Rating</option>
        </select>
 
        <select name='sortby' onChange={(e) => changeSortType(e.target.value)}>
          <option value="Ascending">Ascending</option>
          <option value="Descending">Descending</option>
        </select>
      </div>
 
      <div className="post-container">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <ProductCard
              key={product.id}
              id={product.id}
              title={product.title || product.name || "Unnamed Product"}
              price={product.price}
              rating={product.rating || 0}
              image={product.images?.[0] || "https://via.placeholder.com/150"}
              onClick={() => handleProductClick(product)}
            />
          ))
        ) : (
          <p className='no-product-card'>No products found</p>
        )}
      </div>
    </div>
  );
}
 
export default Search;